import React, { useState } from "react";
import userRole from "../../../Data/user-role.json";
import rolePriv from "../../../Data/role-privilege.json";
import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";

const RVAnalytics = () => {
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedRole, setSelectedRole] = useState(null);
    const [search, setSearch] = useState("");
    console.log(search);

    // To fetch the role and privileges by user starts here
    const { useFetch: userRolePrivFetch } = useAPIQuery({
        key: "api/assign-user-role",
        endpoint: "/api/assign-user-role/",
    });

    const { data: userRolePrivi } = userRolePrivFetch({
        params: { action: "fetch-user-role" },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });
    // To fetch the role and privileges by user starts here

    const getUserRoles = (user) =>
        user?.roles?.map((role) => role.role_name) || [];

    const getPrivilegesByRoles = (roles) => {
        let privilegeMap = {};
        roles.forEach((role) => {
            role.privilege.forEach((priv) => {
                if (!privilegeMap[priv.privilege_name]) {
                    privilegeMap[priv.privilege_name] = new Set();
                }
                privilegeMap[priv.privilege_name].add(role.role_name);
            });
        });
        return privilegeMap;
    };

    const selectedRoles = selectedUser ? getUserRoles(selectedUser) : [];
    const privilegeMap = selectedUser
        ? getPrivilegesByRoles(selectedUser.roles)
        : {};
    const commonPrivileges = Object.keys(privilegeMap).filter(
        (priv) => privilegeMap[priv].size === selectedRoles.length
    );

    const rolePrivileges = selectedRole
        ? Object.entries(privilegeMap).filter(([_, roles]) =>
              roles.has(selectedRole)
          )
        : Object.entries(privilegeMap);

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content d-flex">
                        <h3 className="nk-block-title page-title">
                            RV Analytics
                        </h3>
                    </div>
                </div>
            </div>
            <div className="nk-block nk-block-lg">
                <div className="card card-preview">
                    <div className="card-inner-group">
                        <div className="card-inner">
                            <div className="row">
                                <div className="col-12">
                                    <div className="form-control-wrap mb-3">
                                        <div className="input-group">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Search.."
                                                onChange={(e) =>
                                                    setSearch(e.target.value)
                                                }
                                            />
                                            <div className="input-group-append">
                                                <span
                                                    className="input-group-text"
                                                    id="basic-addon2"
                                                >
                                                    <em class="icon ni ni-search"></em>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="card card-full">
                                        <div className="card-inner">
                                            <div className="card-title-group">
                                                <div className="card-title">
                                                    <h6 className="title">
                                                        Users
                                                    </h6>
                                                </div>
                                            </div>
                                        </div>
                                        <ul className="nk-activity">
                                            {userRolePrivi?.data?.user?.map(
                                                (user) => (
                                                    <li
                                                        style={{
                                                            cursor: "pointer",
                                                        }}
                                                        key={user.id}
                                                        className={`nk-activity-item ${
                                                            selectedUser?.id ===
                                                            user.id
                                                                ? "active"
                                                                : ""
                                                        }`}
                                                        onClick={() => {
                                                            setSelectedUser(
                                                                user
                                                            );
                                                            setSelectedRole(
                                                                null
                                                            );
                                                        }}
                                                    >
                                                        <div className="nk-activity-data">
                                                            <div className="lead-text">
                                                                {user.first_name &&
                                                                user.last_name
                                                                    ? user.first_name +
                                                                      " " +
                                                                      user.last_name
                                                                    : ""}
                                                            </div>
                                                        </div>
                                                    </li>
                                                )
                                            )}
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="card card-full">
                                        <div className="card-inner">
                                            <div className="card-title-group">
                                                <div className="card-title">
                                                    <h6 className="title">
                                                        Roles
                                                    </h6>
                                                </div>
                                            </div>
                                        </div>
                                        {selectedUser ? (
                                            <ul className="nk-activity">
                                                {selectedRoles.map((role) => (
                                                    <li
                                                        key={role}
                                                        className={`nk-activity-item ${
                                                            selectedRole ===
                                                            role
                                                                ? "active"
                                                                : ""
                                                        }`}
                                                        style={{
                                                            cursor: "pointer",
                                                        }}
                                                        onClick={() =>
                                                            setSelectedRole(
                                                                role
                                                            )
                                                        }
                                                    >
                                                        <div className="nk-activity-data">
                                                            <div className="lead-text">
                                                                {role}
                                                            </div>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <p
                                                style={{
                                                    textAlign: "center",
                                                    color: "#777",
                                                }}
                                            >
                                                Select a user to see roles
                                            </p>
                                        )}
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="card card-full">
                                        <div className="card-inner">
                                            <div className="card-title-group">
                                                <div className="card-title">
                                                    <h6 className="title">
                                                        Privileges
                                                    </h6>
                                                </div>
                                            </div>
                                        </div>
                                        {selectedUser ? (
                                            <ul className="nk-activity">
                                                {rolePrivileges.map(
                                                    ([privilege, roles]) => (
                                                        <li
                                                            key={privilege}
                                                            className="nk-activity-item"
                                                            style={{
                                                                fontWeight:
                                                                    commonPrivileges.includes(
                                                                        privilege
                                                                    )
                                                                        ? "bold"
                                                                        : "normal",
                                                            }}
                                                        >
                                                            <div className="nk-activity-data">
                                                                <div className="label">
                                                                    {privilege}{" "}
                                                                    -{" "}
                                                                    {Array.from(
                                                                        roles
                                                                    ).join(
                                                                        ", "
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </li>
                                                    )
                                                )}
                                            </ul>
                                        ) : (
                                            <p
                                                style={{
                                                    textAlign: "center",
                                                    color: "#777",
                                                }}
                                            >
                                                Select a user to see privileges
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <style>
                {`
          .nk-activity-item.active {
            background-color: #007bff;
            color: #fff !important;
            border-radius: 5px;
          }
        `}
            </style>
        </>
    );
};

export default RVAnalytics;
